module.exports = __webpack_public_path__ + "static/img/samajuri (33).91d256f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (33).jpg
// module id = h4Ca
// module chunks = 0